<template>
  <div class="map_container">
    <svg class="base_map" ref="svgMap" width="100%" :height="height">
      <g ref="world_countries"></g>
      <g ref="world_lines"></g>
    </svg>
  </div>
</template>

<style> 

  path.country-path {
    stroke: #ffffff;
    fill: #bbbbbb80;
    stroke-width: 1;
  }

  path.pandora-link {
    stroke-dasharray: 100%;
    fill: transparent;
    stroke: #fff;
  }

  path.active {
    fill: var(--app-color-red) !important;
  }

  svg.base_map {
    opacity: 1;
    transition: opacity 1.5s ease-in-out;
  }

</style>

<script>
  import { find } from 'lodash'
  import * as d3 from 'd3'
  import { geoMercator } from 'd3-geo'

  export default {
    name: 'PlayerMapHeader',
    props: {
      scaleTo: [Number, String],
      centerTo: Array,
      activeCountry: String
    },
    mounted() {
      this.renderMap()
    },
    data() {
      return {
        openMenu: false,
        width: 720,
        height: 750,
        center: [],
        scale: 300,
        distance: 0,
        bounds: [],
        center_device: [],
        zoomed: false
      }
    },
    watch: {
      activeCountry(val) {
        const center = this.findCountry(val).center
        this.renderCountries()
        setTimeout(() => {
          this.zoomTo(center, this.scaleTo)
        }, 100);        
      }
    },
    computed: {
			world_json() {
				return require("../data/worldmap.json")
			},
      projection () {
        return geoMercator()
          .translate([this.width/2, this.height/2])
          .scale(this.scale)
      },
			path () {
        return d3.geoPath().projection(this.projection)
      },
    },
    methods: {
      zoomTo(center, scale) {
        let base = d3.select(this.$refs['world_countries'])
        // let center, scale

        const r = d3.interpolate(this.center, center)
        const s = d3.interpolate(this.scale, scale)

        base.selectAll('path.country-path')
          .transition()
          .duration(750)
          .attrTween('d', (d) => {
            return (t) => {
              this.projection
                .scale(s(Math.pow(t,2)))                    
                .center(r(Math.pow(t,0.33)))
                .translate(this.center_device)                    
                
                this.path.projection(this.projection)

              return this.path(d)
            }
          })
					.on('start', () => {
            this.zoomed = !this.zoomed
          })
					.on('end', () => {
            this.scale = scale
            this.center = center
            this.zoomed = !this.zoomed
              
          })
      },
      findCountry(value) {
        const country = find(this.world_json.features, item => {
          if(item.properties.iso_a3 == value) {
            return item
          }
        })

        return {
          country: country,
          center: this.projection.invert(this.path.centroid(country))
        }
      },
      renderMap() {
        this.height = Math.max(250, window.innerWidth * 2 / 3)
				this.bounds = d3.geoBounds(this.world_json)
        this.width = document.querySelector(".map_container").offsetWidth
				this.distance = d3.geoDistance(this.bounds[0], this.bounds[1])

				this.center_device = [this.width/2, this.height/3.2]
        this.scale = this.scaleTo
        this.center = this.findCountry(this.activeCountry).center
        
				this.projection
					.translate(this.center_device)
          .scale(this.scale)
          .center(this.center)
        
        this.renderCountries()
      },
      renderCountries() {
        let base = d3.select(this.$refs['world_countries'])
				base.selectAll('path.country-path').remove()
        base.selectAll('path')
          .data(this.world_json.features)
          .enter()
          .append('path')
          .attr('d', this.path)
          .attr('id', d => {
            return `${d.properties.iso_a3}`
          })
          .attr('class', d => {
            if(d.properties.iso_a3 == this.activeCountry) {
              return `active country-path path-${d.properties.iso_a3}`
            }
            return `country-path path-${d.properties.iso_a3}`
          })
      }
    }
  }
</script>